<template>
  <md-field class='input' :class='{ "md-invalid": errors.length }'>
    <label v-if='label'>
      {{ label }}
    </label>
    <md-textarea
        :value='value'
        @input='onChange'
        :placeholder='placeholder'
        :disabled='disabled'
        v-bind='inputProps'
    />
    <span
        class='md-error'
        v-if='errors.length'
        v-for='error in errors'
    >
      {{ $t(`errors.${error}`) }}
    </span>
  </md-field>
</template>

<script>
  export default {
    name: 'x-textarea',
    model: {
      prop: 'value',
      event: 'update'
    },
    props: {
      inputProps: {
        type: Object,
        default: () => ({})
      },
      value: {
        type: [String, Number]
      },
      label: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      errors: {
        type: Array,
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onChange (value) {
        this.$emit('update', value)
      }
    }
  }
</script>
